import React from 'react'

const WorkAssigned = () => {
  return (
    <div>WorkAssigned</div>
  )
}

export default WorkAssigned